import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { ActiveCartService } from '@spartacus/cart/base/core';
import { OccEndpointsService, UserIdService } from '@spartacus/core';
import { Observable, combineLatest, of, switchMap } from 'rxjs';
import { catchError, mergeMap, take } from 'rxjs/operators';

import { DpUrlService } from '@app/core/services/url.service';

import { ShippingAccountErrors, ShippingAccountList } from '../modules/delivery-mode/types';

@Injectable({
  providedIn: 'root'
})
export class DpShippingAccountService {
  constructor(
    protected userIdService: UserIdService,
    protected httpClient: HttpClient,
    protected occEndpointsService: OccEndpointsService,
    private readonly dpUrlService: DpUrlService,
    private readonly activeCartService: ActiveCartService
  ) {}

  getShippingAccountsForCustomer(): Observable<ShippingAccountList | ShippingAccountErrors> {
    return this.userIdService.getUserId().pipe(
      take(1),
      switchMap((userId) =>
        this.httpClient
          .get<ShippingAccountList>(this.occEndpointsService.buildUrl(`/users/${userId}/shippingaccounts?fields=FULL`))
          .pipe(catchError((data: HttpErrorResponse) => of(data.error as ShippingAccountErrors)))
      )
    );
  }

  setDeliveryMode(modeCode: string, shippingAccount?: string): Observable<object> {
    return combineLatest([
      this.userIdService.getUserId(),
      this.activeCartService.getActiveCartId(),
      this.dpUrlService.urlParts$
    ]).pipe(
      take(1),
      mergeMap(([userId, cartId, { market }]) => {
        const endpoint = shippingAccount ? '/shippingaccount' : '';
        const queryParamName = shippingAccount ? 'deliveryModeCode' : 'deliveryModeId';
        const usersEndpointPart = shippingAccount ? 'orgUsers' : 'users';
        const baseUrl =
          `${this.dpUrlService.API_ROUTE}/${market}` +
          `/${usersEndpointPart}/${userId}` +
          `/carts/${cartId}` +
          `/deliverymode${endpoint}` +
          `?${queryParamName}=${modeCode}`;

        const optionsQuery = shippingAccount ? `&shippingAccountCode=${shippingAccount}` : '';

        return this.httpClient.put(baseUrl + optionsQuery, {});
      })
    );
  }
}
